// Constants
import { PUSH_NOTIFICATIONS_SUGGESTION_SHOWN } from './pushSuggestionConstants';

export const pushSuggestionPopupShown = () => ({
    type: PUSH_NOTIFICATIONS_SUGGESTION_SHOWN,
});
